<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ props: dialogProps }">
      <v-tooltip location="bottom" color="primary">
        <template v-slot:activator="{ props: tooltipProps }">
          <v-btn
            icon
            density="compact"
            size="small"
            variant="text"
            v-bind="{ ...tooltipProps, ...dialogProps }"
          >
            <v-icon color="primary">mdi-information</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("labels.property") }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list density="compact">
          <v-list-item
            v-for="(property, i) in properties"
            :key="i"
            color="primary"
          >
            <v-list-item-title>{{ property.name }}:</v-list-item-title>
            <v-list-item-subtitle>{{ property.value }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogEntityProperty",
  props: ["name", "properties"],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    confirm() {
      this.dialog = false;
      this.$emit("confirm");
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped></style>
